import { render, staticRenderFns } from "./StorageSidebar.vue?vue&type=template&id=796aaa86&scoped=true"
import script from "./StorageSidebar.vue?vue&type=script&lang=js"
export * from "./StorageSidebar.vue?vue&type=script&lang=js"
import style0 from "./StorageSidebar.vue?vue&type=style&index=0&id=796aaa86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796aaa86",
  null
  
)

export default component.exports